<template>
    <div class="bg" v-if="isLoaded">
        <div style="padding: 5%;">
            <div
                style="display: flex;justify-content: center;margin-top: 3vh;color: #131313;font-size: 3.8vh;font-weight: 600;">
                欢迎您使用{{ $siteConfig.siteName }}
            </div>
            <div
                style="display: flex;justify-content: center;margin-top: 0.5vh;color: rgb(30, 30, 30);font-size: 2.7vh;">
                一键创作短视频
            </div>
            <div
                style="background-color: rgb(255, 255, 255);margin-top: 4.5vh;padding: 3vh;border-radius: 20px;z-index: 2;position: relative;box-shadow: 0px 10px 10px rgba(52, 52, 52, 0.1);">
                <div style="font-size: 2.8vh;">
                    注册
                </div>
                <div style="margin-top: 28px;">
                    <el-input v-model="phone" placeholder="请输入手机号" :maxlength="11"
                        oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                </div>
                <div style="margin-top: 14px;" v-if="phone.length == 11">
                    <el-input v-model="pass" placeholder="请输入密码" show-password :maxlength="12"></el-input>
                </div>
                <div @click="zc"
                    style="background-color: rgb(55, 96, 245);color: #fff;padding: 0.75em;text-align: center;margin-top: 4vh;border-radius: 10px;font-size: 1em;cursor: pointer;position: relative;"
                    class="fireworks">
                    立即注册
                    <div
                        style="position: absolute;top: 0;right: 0;font-size: 0.5em;padding: 2px 5px 2px 7px;background-color: #c60000;border-radius: 0px 10px 0px 7px;">
                        100万人已注册
                    </div>
                </div>
                <div style="height: 2vh;">

                </div>
            </div>
            <div style="background-color: rgba(255, 255, 255, 0.8);padding: 3vh;border-radius: 20px;margin-top: -4vh;">
                <div style="display: flex;flex-wrap: wrap;margin-top:40px">
                    <div style="font-size: 2.0vh;width: 50%;text-align: center;margin-bottom: 20px;color: #444;"
                        v-for="(item, index) in gn" :key="index">
                        <i :class="item.icon" style="font-weight: 600;margin-right: 3px;font-size: 2.2vh;"
                            :style="'color:' + item.color"></i>{{ item.name }}
                    </div>
                </div>
                <div style="text-align: center;color: #666;font-size: 1.5vh;">
                    ...更多功能
                </div>

            </div>
            <div style="position: absolute;bottom: 0;left: 0;right: 0;display: flex;justify-content: center;">
                <div style="display: flex;align-items: center;" @click="$router.push('/')">
                    <el-image style="width: 33px;padding: 5px;" :src="require('@/assets/img/qhy2.png')"></el-image>
                    <div style="font-size: 20px;">
                        {{ $siteConfig.siteName }}
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import WebFont from 'webfontloader';
export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
        return {
            upid: 0,
            phone: '',
            pass: '',
            gn: [
                {
                    'name': '一键去重',
                    'icon': 'el-icon-scissors',

                },
                {
                    'name': '智能混剪',
                    'icon': 'el-icon-refresh',

                },
                {
                    'name': '好物视频',
                    'icon': 'el-icon-present',

                },
                {
                    'name': '起号视频',
                    'icon': 'el-icon-film'
                },
            ],
            loading: '',
            isLoaded: false
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        zc() {
            if (!this.phone || !this.pass) {
                // this.$msg.error('请输入手机号和密码')
                this.$toast.show('请输入手机号和密码');
                return
            }
            if (this.pass.length < 6) {
                // this.$msg.error('密码最少6位')
                this.$toast.show('密码最少6位');
                return
            }
            var reg = /^1\d{10}$/;
            if (!reg.test(this.phone)) {
                // this.$msg.error('手机号不正确')
                this.$toast.show('手机号不正确');
                return
            }

            var data = {
                phone: this.phone,
                password: this.pass,
                upid: this.$route.query.s
            }
            const loading = this.$loading(this.$loadinginfo);
            this.$ajax.post('qhy/login/regs', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    // this.$msg.success(res.data.msg)
                    this.$alert('注册成功！', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        customClass: 'msbox',
                        callback: action => {
                            this.$router.push('/')
                        }
                    });


                } else {

                    if (res.data.msg == '此手机号已被注册') {
                        this.$confirm('此手机号已被注册, 是否去登录?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            customClass: 'msbox',
                            type: 'warning'
                        }).then(() => {
                            this.$router.push('/login')
                        }).catch(() => {

                        });
                    } else {
                        this.$msg.error(res.data.msg)
                    }
                }
                loading.close();
            })
        },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        const ua = navigator.userAgent.toLowerCase();
        const t1 = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(
            ua
        );
        // const t2 = !ua.match("iphone") && navigator.maxTouchPoints > 1;
        if (!t1) {
            this.$router.push('/register?s=' + this.$route.query.s)
        }

        const loading = this.$loading(this.$loadinginfo);
        this.isLoaded = true
        loading.close();
        // WebFont.load({
        //     custom: {
        //         families: ['dd-font'], // 自定义字体名称
        //         urls: ['@/assets/fonts/fonts.css'] // 包含字体定义的 CSS 文件路径
        //     },
        //     active: () => {
        //         this.isLoaded=true
        //         loading.close();
        //     },
        //     inactive: () => {
        //         loading.close();
        //     }
        // });
    },
    beforeCreate() {

    }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
html {
    touch-action: manipulation;

}

html,
body {
    overscroll-behavior: none;
    font-family: "Roboto", Arial, sans-serif;
}

body {
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
}

.bg {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    /* 纯CSS蓝色渐变背景 */
    background:
        radial-gradient(ellipse 80% 50% at 50% 50%, rgba(0, 100, 255, 0.8) 0%, transparent 80%),
        radial-gradient(ellipse 60% 40% at 20% 70%, rgba(30, 80, 255, 0.6) 0%, transparent 70%),
        radial-gradient(ellipse 40% 60% at 80% 30%, rgba(50, 100, 220, 0.5) 0%, transparent 60%),
        linear-gradient(135deg, #d6ebff 0%, #b3d9ff 100%);
    background-size: cover;
    background-position: center;
    /* padding: 5%; */
    /* font-family: dd-font; */
}

/* 改变input框背景颜色 */
div /deep/ .el-input__inner {
    background-color: RGB(250, 250, 250);
    border-color: rgb(222, 222, 222);
    padding: 1.4em 1.1em;
    font-size: 1em;
}

div /deep/ .el-input__inner::placeholder {
    color: rgb(164, 164, 164);
}

.fireworks {
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(1);
        /*开始为原始大小*/
    }

    50% {
        transform: scale(1.03);
        /*放大1.1倍*/
    }

    100% {
        transform: scale(1);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ShareApp.vue